import { CurrentUserDto } from '../../../../../types/UserDtos';
import * as R from '../../../../routes';
import { isFeatureEnabled } from '../../../services/Features';
import { goToUrl } from '../../../services/Router';
import { prependAppPath } from '../../../services/Url';
import { isGuest } from '../../../services/User';

export const closeFeedbackZenMode = (currentUser: CurrentUserDto, prevPath: string | undefined) => {
    const newFeedbackDefaultRoute = isGuest(currentUser) ? R.FEEDBACK_USER_TODO : R.FEEDBACK_USER_FOR_YOU;
    const defaultClosePath = isFeatureEnabled('FEATURE_adminNavigationRefresh')
        ? prependAppPath(newFeedbackDefaultRoute)
        : prependAppPath(R.FEEDBACK_USER) + '?tab=todo';
    goToUrl(prevPath || defaultClosePath);
};
